import React from 'react';

// Classnames
import clsx from 'clsx';

// Lib
import { shallowEqual } from 'react-redux';
import { useAppDispatch, useAppSelector } from 'lib/hooks/useDispatch';
import {
	convertedToArray,
	convertProjectsToOptions,
	generateXLSTableSave
} from 'lib/helpers';

// Components
import Img from 'components/Img';
import Button from 'components/UiKit/Button';
import FieldText from 'components/UiKit/FieldText';
import FieldSelect from 'components/UiKit/FieldSelect';
import FieldCheckbox from 'components/UiKit/FieldCheckbox';

// Lib
import { useWindowSize } from 'lib/hooks';

// Actions
import { openModal } from 'reducers/modal';
import { showMessage } from 'reducers/messages';
import { handlerChangePriceApp, toggleModal } from 'reducers/settings';

// Type
import * as actionsCreatorSearch from 'pages/Search/reducer';
import * as actionsCreatorProject from 'pages/Projects/reducer';
import * as actionsCreatorThesaurus from 'pages/Thesaurus/reducer';
import { handlerChangeAllPrices, TBaData } from 'pages/Thesaurus/reducer';

// Constants
import {
	headersXLS,
	ON_STOCK_POA,
	optionsPxByMax,
	optionsPxByMin,
	optionsTarActionMax,
	optionsTarActionMin,
	optionsTargetByMax,
	optionsTargetByMin,
	OUT_OF_STOCK,
	styleFieldSelectAvailability,
	styleFieldSelectPrepackage,
	styleFieldSelectProject,
	styleFieldSelectTarActions
} from 'constans/search';

type PropsOptions = {
	[index: string]: string | number
};
type TFuncArgs = {
	[index: string]: string | number | undefined;
}
type TOptions = {
	label?: string;
	value?: string;
};
type TOptSort = {
	key?: string,
	typeSort?: string,
};

interface IHeaderList {
	isModal?: boolean;
	className?: string;
}

export const HeaderList: React.FC<IHeaderList> = (props) => {
	const { isModal = false, className = '' } = props;
	const dispatch = useAppDispatch();

	const { width } = useWindowSize();

	const {
		user,
		typeTab,
		currentPrice,
		dataProjects,
		currentProject,
		structureData
	} = useAppSelector(
		(store) => {
			return {
				typeTab: store.thesaurus.typeTab,
				currentPrice: store.settings.currentPrice,

				user: store.settings.user,
				dataProjects: store.projects.dataProjects,
				currentProject: store.projects.currentProject,

				structureData: store.thesaurus.structureData
			};
		},
		shallowEqual
	);

	const isDesktop = width < 1024;
	const tarPx = structureData && typeTab ? (structureData as Record<string, any>)[typeTab]?.tarPx : [];
	const data = structureData && typeTab ? (structureData as Record<string, any>)[typeTab]?.content : [];
	const tarAction = structureData && typeTab ? (structureData as Record<string, any>)[typeTab]?.tarAction : [];
	const availability = structureData && typeTab ? (structureData as Record<string, any>)[typeTab]?.availability : [];
	const checkboxAll = structureData && typeTab ? (structureData as Record<string, any>)[typeTab]?.checkboxAll : false;
	const optionsTarAction = structureData && typeTab ? (structureData as Record<string, any>)[typeTab]?.optionsTarAction : [];
	const optionsAvailability = structureData && typeTab ? (structureData as Record<string, any>)[typeTab]?.optionsAvailability : [];

	const prices = data?.length ? data[0]?.prices[0].prices : [];
	const convertedProjects = convertedToArray(dataProjects);
	const optionsProjects = convertProjectsToOptions(dataProjects);
	const projectValue = user?.authorized
		? optionsProjects?.find(
			(item: PropsOptions) => item.value === +currentProject
		)
		: [];

	const options: any = prices?.length
		? prices?.map(
			(item: any) => {
				return {
					type: 'Usd',
					label: `${item.mg}mg`,
					mg: item.mg ? item.mg : null,
					value: item.mg ? `price${item.mg}mg` : '',
					price: item?.priceUsd ? item?.priceUsd : null
				};
			}
		)
		: [];

	const handlerSubmit = () => {
		if (!user.authorized) {
			dispatch(toggleModal(true));
			return;
		}

		const uniqId = crypto.randomUUID();
		let result: TBaData[] = [];

		for (const item of data || []) {
			const hasPrices = Object.values(item?.currentPrice)
				.filter(Boolean)
				.length;

			if (
				item.selected &&
				!hasPrices
			) {
				dispatch(showMessage({
					type: 'info',
					uniqId: uniqId,
					text: 'Choose price/mg'
				}));
				result = [];
				return;
			}

			if (
				item.selected &&
				hasPrices
			) result.push(item);
		}

		const newData = result.map((item) => {
			const findElement = data?.find((elem: any) => elem?.id === item?.id);
			const prices = findElement.prices;
			const currentTypePrice = findElement.currentTypePrice;
			const findTypePrice = prices && prices.find(
				(x: any) => x.supplier === currentTypePrice
			) ? currentTypePrice : prices && prices[0]?.supplier;
			const findPrice = prices?.find((item: any) => item.supplier === findTypePrice);
			const price = findPrice?.prices?.find((item: any) => item.mg === currentPrice?.mg);
			const formData = {
				type: 'Usd',
				mg: price.mg,
				price: price.priceUsd,
				label: `${price.mg}mg`,
				value: `price${price.priceUsd}mg`
			};

			return {
				...item,
				supplier: findTypePrice,
				currentPrice: price?.priceUsd ? formData : currentPrice
			};
		});

		if (currentProject && newData.length) {
			dispatch(actionsCreatorProject.addItemToProject({
				data: newData,
				uniqId: uniqId,
				id: currentProject,
				title: 'Compound Added to project',
				text: 'Review or continue browsing. Contact<br/> us for any questions. Thank you!'
			}));
			return;
		}

		const itemsWithValidPrice = newData.filter(
			(item: any) => item.currentPrice && item.currentPrice.mg
		);

		if (!currentProject && itemsWithValidPrice.length) {
			const modalConfig = {
				data: newData,
				isAddItem: 'isAddItem',
				title: 'Compound Added to project',
				type: convertedProjects.length ? 'projectsList' : 'projectAdd',
				text: 'Review or continue browsing. Contact<br/> us for any questions. Thank you!'
			};

			dispatch(openModal(modalConfig));
		}
	};

	const handlerConfirmChangePrice = (selected: TFuncArgs) => {
		dispatch(openModal(
			{
				data: selected,
				color: 'error',
				type: 'confirm',
				textClose: 'Cancel',
				textSubmit: 'Confirm',
				actionSubmit: handlerChangePrices,
				innerClass: 'libraries-compounds__confirm',
				text: `The default prepackage size of all compounds will be set to ${selected.mg} mg`
			})
		);
	};

	const handlerChangePrices = (selected: TFuncArgs) => {
		dispatch(handlerChangePriceApp(selected));
		dispatch(handlerChangeAllPrices(selected));
	};

	const handlerChangeProject = (selected: TOptions) => {
		dispatch(
			actionsCreatorProject.handlerChangeCurrentProject(selected.value)
		);
	};

	const handlerClickSort = (opt: TOptSort) => () => {
		dispatch(actionsCreatorThesaurus.handlerChangeSortItems(opt));
	};

	const handlerChangeTarPx = (e: React.ChangeEvent<HTMLInputElement>) => {
		dispatch(actionsCreatorThesaurus.handlerChangeTarPx(e.target.value));
	};

	const handlerChangeTarAction = (selected: TOptions) => {
		dispatch(actionsCreatorThesaurus.handlerChangeTarAction(selected));
	};

	const handlerChangeAvailability = (selected: TOptions) => {
		dispatch(actionsCreatorThesaurus.handlerChangeAvailability(selected));
	};

	const handlerChangeCheckboxAll = (e: React.ChangeEvent<HTMLInputElement>) => {
		dispatch(actionsCreatorThesaurus.handlerChangeCheckboxAll(e.target.checked));
	};

	const handlerChangeClearSelected = () => {
		dispatch(actionsCreatorThesaurus.handlerChangeClearSelected());
	};

	const handlerDownloadPOA = () => {
		generateXLSTableSave({ data: data, headers: headersXLS });
	};

	const isAvailabilityValid = (value: string) => {
		return value !== OUT_OF_STOCK && value !== ON_STOCK_POA;
	};

	const handleChangeToggleFilter = () => {
		dispatch(actionsCreatorSearch.changeToggleFilter());
	};

	const cnTarId = clsx(
		'search-bio__sub-header-text search-bio__tar-id',
		!isAvailabilityValid(availability?.value || '') ? 'search-bio__tar-id--active' : ''
	);

	const selectedCount = data?.filter((item: TBaData) => item.selected)?.length;

	const cnWrapper = clsx(
		'search-bio__wrapper-table-header flex flex-direction-column',
		className ? className : ''
	);

	const icon = isModal
		? 'crossSvg'
		: 'filterSvg';

	return (
		<div className={cnWrapper}>
			<div className="search-bio__block-controller flex flex-ai-end flex-jc-between full-width">
				<div className="search-bio__block-controller-left flex flex-ai-end flex-jc-between">
					{isDesktop && isAvailabilityValid(availability?.value || '') && <FieldCheckbox
						label="Choose all"
						value={checkboxAll}
						name="checkboxItemAll"
						onChange={handlerChangeCheckboxAll}
						className="search-bio__checkbox-all ml10"
						classNameLabel="search-bio__checkbox-all-label"
					/>}

					<p className="search-bio__filters-text">Filters</p>

					<div className="search-bio__block-selected relative flex flex-ai-end">
						<div className="flex flex-ai-start flex-direction-column">
							<p className="search-bio__block-selected-text">Selected</p>
							<p className="search-bio__count-table">{selectedCount} of {data?.length}</p>
						</div>

						<div className="flex flex-ai-center">
							<Button
								isSvg
								variable="icon"
								color="error"
								icon="deleteSvg"
								disabled={!selectedCount}
								onPress={handlerChangeClearSelected}
								className="search-bio__icon-delete ml10 mr20"
							/>
						</div>
					</div>

					<Button
						isSvg
						icon={icon}
						title="Filter"
						variable="icon"
						onPress={handleChangeToggleFilter}
						className="pfizer__header-select-icon display-block-mobile"
					/>
				</div>

				<div className="search-bio__flex-1 flex flex-ai-center flex-jc-between" id="bio-search-list-filter">
					<FieldText
						step="0.1"
						name="tarPx"
						label="pX ≥"
						value={tarPx}
						innerTypeInput="number"
						style={{ width: '6rem' }}
						onChange={handlerChangeTarPx}
						className="field-select__custom-label search-bio__field-tar-px"
					/>

					<FieldSelect
						name="tarAction"
						value={tarAction}
						label="Target action"
						options={optionsTarAction}
						onChange={handlerChangeTarAction}
						styles={styleFieldSelectTarActions}
						className="field-select__custom-label search-bio__field-tar-action"
					/>

					<FieldSelect
						name="availability"
						label="Availability"
						value={availability}
						options={optionsAvailability}
						onChange={handlerChangeAvailability}
						styles={styleFieldSelectAvailability}
						className="field-select__custom-label search-bio__field-availability"
					/>

					<FieldSelect
						options={options}
						name="pricesListAll"
						value={currentPrice}
						placeholder="Prepack"
						label="Default prepackage"
						styles={styleFieldSelectPrepackage}
						onChange={(value: TFuncArgs, opt: TFuncArgs) => {
							if (opt.action === 'select-option') {
								handlerConfirmChangePrice(value);
							}
						}}
						title="Prepackage for seleted compounds"
						className="search-bio__field-default-prepackage field-select__custom-label"
					/>
				</div>

				<div className="search-bio__block-controller-right flex flex-ai-end" id="cart-bio__uniq-id-btn">
					<FieldSelect
						name="projectName"
						value={projectValue}
						options={optionsProjects}
						disabled={!user.authorized}
						placeholder="Last project name"
						onChange={handlerChangeProject}
						styles={styleFieldSelectProject}
						className="search-bio__field-project-name mr30"
					/>

					{availability?.value !== ON_STOCK_POA && <Button
						variable="info"
						onPress={handlerSubmit}
						disabled={!selectedCount}
						label="Buy selected compounds"
						className="search-bio__button-buy-selected-compounds"
					/>}

					{availability?.value === ON_STOCK_POA && !!data?.length && <Button
						variable="info"
						label="Download to XLS"
						onPress={handlerDownloadPOA}
						className="ml10 align-self-end mb5"
					/>}
				</div>
			</div>

			<div className="search-bio__sub-header flex flex-ai-center relative">
				{isAvailabilityValid(availability?.value || '') && <FieldCheckbox
					label="Choose"
					className="ml10"
					value={checkboxAll}
					name="checkboxItemAll"
					onChange={handlerChangeCheckboxAll}
					classNameLabel="search-bio__checkbox-all"
				/>}

				<p className={cnTarId}>EBC ID & CAS</p>
				<p title="Sort by text target px"
					 className="search-bio__sub-header-text search-bio__text-tar flex flex-ai-center">
					Target<span
					className="search-bio__block-shevron ml10 flex flex-direction-column">
            <span
							className="search-bio__shevron-top"
							onClick={handlerClickSort(optionsTargetByMax)}
						>
              <Img isSvg name="arrowTopSvg" />
            </span>
            <span
							className="search-bio__shevron-bottom"
							onClick={handlerClickSort(optionsTargetByMin)}
						>
              <Img isSvg name="arrowBottomSvg" />
            </span>
          </span>
				</p>
				<p title="Sort by text px"
					 className="search-bio__sub-header-text search-bio__text-px flex flex-ai-center">pX<span
					className="search-bio__block-shevron ml10 flex flex-direction-column">
            <span
							className="search-bio__shevron-top"
							onClick={handlerClickSort(optionsPxByMax)}
						>
              <Img isSvg name="arrowTopSvg" />
            </span>
            <span
							className="search-bio__shevron-bottom"
							onClick={handlerClickSort(optionsPxByMin)}
						>
              <Img isSvg name="arrowBottomSvg" />
            </span>
          </span></p>
				<p className="search-bio__sub-header-text search-bio__text-tar-action flex flex-ai-center">Tar action<span
					className="search-bio__block-shevron ml10 flex flex-direction-column">
          <span
						className="search-bio__shevron-top"
						onClick={handlerClickSort(optionsTarActionMax)}
					>
            <Img isSvg name="arrowTopSvg" />
          </span>
          <span
						className="search-bio__shevron-bottom"
						onClick={handlerClickSort(optionsTarActionMin)}
					>
            <Img isSvg name="arrowBottomSvg" className="" />
          </span>
        </span></p>
				<p className="search-bio__sub-header-text search-bio__text-tar-refs">Target references</p>
				<p className="search-bio__sub-header-text search-bio__accessibility">Accessibility</p>
				<p className="search-bio__sub-header-text">Price</p>
			</div>
		</div>
	);
};

export default HeaderList;
